<style lang="scss" scoped>
.sub-navbar {
    height: 70px;
    background: #fff;
    z-index: 1;
    border-bottom: 1px solid #e1e9ed;
    .flex-auto {
        flex: auto;
    }
}
</style>

<template>
    <header class="row sub-navbar">
        <div class="container d-flex">
            <div class="row align-content-center flex-auto">
                <div class="col-auto d-flex flex-row align-items-center">
                    <slot name="breadcrumbs"></slot>
                </div>
                <div class="col-auto ml-auto d-flex flex-row align-items-center">
                    <slot name="actions"></slot>
                </div>
            </div>
        </div>
    </header>
</template>

<script>

export default {
    name: 'sub-navbar',

    computed: {

    }
};
</script>
